module.exports = __webpack_public_path__ + "c727bade01c481c98037307eca63d55f.svg";